import {
    FETCH_TAG_COUNTS,
    FETCH_TAG_IDS
} from '../actions/types';

const initialState = {
    items: [],
    item: {}
}

export default function(state=initialState, action) {
    switch(action.type) {
        case FETCH_TAG_COUNTS:
            return {
                ...state,
                items: action.payload
            }
        case FETCH_TAG_IDS:
            return {
                ...state,
                items: action.payload
            }
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/tagReducer.js